import { render, staticRenderFns } from "./Derogation.vue?vue&type=template&id=53a45638"
import script from "./Derogation.vue?vue&type=script&lang=js"
export * from "./Derogation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports